/* nplus-accessories.js — <nplus-accessories> shared selector.
   Classic script. Exposes window.nplusAccessories.getSelection() → [{productId, variantId}]. UI only. */
(function () {
  'use strict';

  class NplusAccessories extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;

      var cfgEl = this.querySelector('.nplus-acc__config');
      try { this.config = JSON.parse(cfgEl ? cfgEl.textContent : '[]'); } catch (e) { this.config = []; }

      var self = this;
      this.defaults = {};
      this.free = {};
      this.linked = {};        // pid → size_variant_map { "<bikePosition>": variantId }
      this.variantsById = {};  // pid → { "<variantId>": variant } (size-linked rows only)
      this.resolved = {};      // pid → variantId matched to current bike size (or null)
      (this.config || []).forEach(function (a) {
        var pid = String(a.productId);
        var firstAvail = (a.variants || []).filter(function (v) { return v.available; })[0];
        self.defaults[pid] = firstAvail ? String(firstAvail.id) : null;
        self.free[pid] = !!a.free;
        if (a.size_linked && a.size_variant_map) {
          self.linked[pid] = a.size_variant_map;
          self.variantsById[pid] = {};
          (a.variants || []).forEach(function (v) { self.variantsById[pid][String(v.id)] = v; });
        }
        self.preselect(pid);
        // Free rows render pre-checked; reveal their variant picker on load.
        if (a.free) self.syncCard(pid);
      });

      Array.prototype.forEach.call(this.querySelectorAll('[data-nplus-acc-include]'), function (cb) {
        cb.addEventListener('change', function () { self.syncCard(cb.getAttribute('data-nplus-acc-product')); });
      });

      // Size-linked rows: drive variant from the bike's selected size. Cache covers buybox
      // connecting first; the event covers it connecting after us.
      this.bikePosition = window.nplusBikePosition != null ? window.nplusBikePosition : null;
      document.addEventListener('nplus:bike-variant-change', function (e) {
        self.bikePosition = e.detail ? e.detail.position : null;
        self.applyAllSizeLinks();
      });
      this.applyAllSizeLinks();

      window.nplusAccessories = this;
    }

    includeEl(pid) { return this.querySelector('[data-nplus-acc-include][data-nplus-acc-product="' + pid + '"]'); }
    variantsWrap(pid) { return this.querySelector('[data-nplus-acc-variants="' + pid + '"]'); }
    radios(pid) { return Array.prototype.slice.call(this.querySelectorAll('[data-nplus-acc-variant][data-nplus-acc-product="' + pid + '"]')); }
    card(pid) { return this.querySelector('.nplus-acc__card[data-nplus-acc-product="' + pid + '"]'); }
    sizeLabelEl(pid) { return this.querySelector('[data-nplus-acc-sizelabel="' + pid + '"]'); }

    applyAllSizeLinks() {
      var self = this;
      Object.keys(this.linked).forEach(function (pid) { self.applySizeLink(pid); });
    }

    // Match the size-linked accessory's variant to the current bike size (by position),
    // update the read-only label, and enable/disable the row by availability.
    applySizeLink(pid) {
      var pos = this.bikePosition;
      if (pos == null) return; // no bike size yet — wait for buybox's dispatch
      var map = this.linked[pid];
      var variantId = map ? map[String(pos)] : null;
      var variant = variantId != null ? this.variantsById[pid][String(variantId)] : null;
      var ok = !!(variant && variant.available);
      var inc = this.includeEl(pid);
      var label = this.sizeLabelEl(pid);
      if (ok) {
        this.resolved[pid] = String(variantId);
        if (inc) inc.disabled = false;
        if (label) {
          label.textContent = label.getAttribute('data-size-prefix') + ': ' + variant.title + ' — ' + label.getAttribute('data-matches-text');
          label.removeAttribute('data-unavailable');
          label.hidden = false;
        }
      } else {
        this.resolved[pid] = null;
        if (inc) { inc.checked = false; inc.disabled = true; }
        if (label) {
          label.textContent = label.getAttribute('data-unavailable-text');
          label.setAttribute('data-unavailable', '');
          label.hidden = false;
        }
        this.syncCard(pid);
      }
    }

    preselect(pid) {
      var radios = this.radios(pid);
      if (!radios.length) return;
      var def = this.defaults[pid];
      var match = radios.filter(function (r) { return r.value === def; })[0] ||
        radios.filter(function (r) { return !r.disabled; })[0];
      if (match) match.checked = true;
    }

    syncCard(pid) {
      var inc = this.includeEl(pid);
      var on = !!(inc && inc.checked);
      var wrap = this.variantsWrap(pid);
      if (wrap) wrap.hidden = !on || this.radios(pid).length === 0;
      var card = this.card(pid);
      if (card) { if (on) card.setAttribute('data-included', ''); else card.removeAttribute('data-included'); }
    }

    // Public API consumed by A (cart), B (deposit), C (leasing).
    getSelection() {
      var self = this;
      var out = [];
      (this.config || []).forEach(function (a) {
        var pid = String(a.productId);
        var inc = self.includeEl(pid);
        if (!inc || !inc.checked) return;
        var variantId;
        if (self.linked[pid]) {
          variantId = self.resolved[pid]; // size-linked: matched to bike size (may be null)
        } else {
          variantId = self.defaults[pid];
          var radios = self.radios(pid);
          if (radios.length) {
            var checked = radios.filter(function (r) { return r.checked; })[0];
            variantId = checked ? checked.value : null;
          }
        }
        if (variantId) {
          var item = { productId: pid, variantId: variantId };
          if (self.free[pid]) item.free = true;
          out.push(item);
        }
      });
      return out;
    }
  }

  if (!customElements.get('nplus-accessories')) {
    customElements.define('nplus-accessories', NplusAccessories);
  }
})();
